import EditSuperUser from './components/EditSuperUser';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter';
import get from 'lodash/get';
import has from 'lodash/has';
import {connect} from 'react-redux';

import {
  loadUser,
  updateUser,
  createProvider,
  checkIfEmailTaken,
  loadLinkInfoForUser
} from '../../shared/redux/entities/actions';

import {
  getActiveProviderUser
} from '../../shared/redux/selectors';

function mapStateToProps(state,props){
  const superuserId = props.match.params.superuserId,
    activeUser = getActiveProviderUser(state),
    isProfile = props.match.path.includes('profile');

  return {
    isUpdate:!!superuserId,
    isCreate:props.match.path.includes('new'),
    isProfile:isProfile,
    superuserId:superuserId,
    activeSuperUserId:activeUser ? activeUser.id : null,
    needsLoading:!has(state,['entities','users',superuserId]),
    existingSuperuser:isProfile ? activeUser :get(state,['entities','users',superuserId])
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadUser,
    updateUser,
    createProvider,
    checkIfEmailTaken,
    loadLinkInfoForUser
  },dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(EditSuperUser));



// WEBPACK FOOTER //
// ./src/routes/EditSuperUser/index.js